(() => {
  function init(root = document) {
    root.querySelectorAll('[data-interest-section]').forEach(section => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const tabs = [...section.querySelectorAll('[role="tab"]')];
      const panels = [...section.querySelectorAll('[role="tabpanel"]')];
      function activate(tab, focus = false) {
        tabs.forEach(t => {
          t.setAttribute('aria-selected', String(t === tab));
          t.tabIndex = t === tab ? 0 : -1;
        });
        panels.forEach(p => { p.hidden = p.id !== tab.getAttribute('aria-controls'); });
        if (focus) tab.focus({ preventScroll: true });
        const strip = tab.parentElement;
        const left = tab.offsetLeft - strip.offsetLeft;
        if (left < strip.scrollLeft) strip.scrollLeft = left;
        else if (left + tab.offsetWidth > strip.scrollLeft + strip.clientWidth) strip.scrollLeft = left + tab.offsetWidth - strip.clientWidth;
      }
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); activate(tabs[next], true); }
        });
      });
      section.querySelectorAll('.shi-more').forEach(button => button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(expanded));
        button.closest('.shi-panel').classList.toggle('shi-expanded', expanded);
        button.textContent = expanded ? 'Show less' : 'Show more';
      }));
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:block:select', event => {
    const panel = event.target.closest('.shi-panel');
    if (panel) document.getElementById(panel.getAttribute('aria-labelledby'))?.click();
  });
})();
